import { animation, style, animate } from '@angular/animations';

export const fadeInAnimation = animation([
    style({ opacity: 0 }),
    animate('400ms', style({ opacity: 1 }))
]);

